<template>
  <div class="common_table">
    <!--highlight-current-row 是否高亮当前行-->
    <vxe-table
      keep-source
      ref="commonTable"
      :height="tableData.config.height"
      :max-height="tableData.config.maxHeight"
      :highlight-hover-row="tableData.config.highlightHoverRow"
      :loading="loading"
      stripe
      :show-header="tableData.config.headerShow"
      :data.sync="tableData.dataList"
      :border="tableData.config.border"
      :resizable="tableData.config.resizable"
      :edit-config="{
        trigger: editTriggerMode,
        mode: editMode,
        showStatus: true,
        activeMethod: activeEditMethod,
        autoClear: editAutoClear
      }"
      auto-resize
      :row-class-name="tableRowClassName ? tableRowClassName : null"
      :cell-class-name="cellClassName ? cellClassName : null"
      @edit-actived="editActivedEvent"
      @edit-closed="editClosed"
      @current-change="handleCurrentChange"
      :row-id="tableData.config.rowId"
      :radio-config="{ checkMethod, trigger: checkboxTrigger }"
      :checkbox-config="{
        checkMethod,
        trigger: checkboxTrigger,
        strict: true,
        reserve: tableData.config.checkboxReserve
      }"
      @radio-change="handleRadioChange"
      @checkbox-change="handleSelectChange"
      @checkbox-all="handleCheckBoxAll"
      @cell-click="handleCellClick"
      @cell-dblclick="handleCellDblclick"
      :show-footer="tableData.config.showFooter"
      :footer-method="footerMethod"
      :merge-footer-items="JSON.parse(JSON.stringify(mergeFooterData))"
      :footer-cell-class-name="footerCellClassName"
      :empty-render="
        tableData.config.customEmpty ? tableData.config.customEmpty : null
      "
      :empty-text="$t('general.NoData')"
    >
      <vxe-table-column
        type="seq"
        align="left"
        fixed="left"
        width="50"
        v-if="tableData.config.showIndex"
      />
      <vxe-table-column
        v-for="item in tableData.columns"
        :key="item.indexID"
        :type="item.type ? item.type : null"
        :width="item.width"
        min-width="80"
        :field="item.prop"
        :sortable="item.field"
        :title="item.title"
        :title-help="item.titleHelp ? item.titleHelp : null"
        :header-class-name="item.headerClassName ? item.headerClassName : null"
        :header-align="item.align ? item.align : 'left'"
        :align="item.align ? item.align : 'left'"
        :fixed="item.fixed ? item.fixed : null"
        :show-header-overflow="
          item.headerOffOverFlow ? item.headerOffOverFlow : false
        "
        :cell-render="item.cellRender ? item.cellRender : null"
        :edit-render="item.editRender ? item.editRender : null"
        :show-overflow="item.offOverFlow ? item.offOverFlow : false"
      >
        <template v-if="item.children && item.children.length > 0">
          <vxe-table-column
            v-for="cItem in item.children"
            :key="cItem.indexID"
            :type="cItem.type ? cItem.type : null"
            :width="cItem.width"
            min-width="80"
            :field="cItem.prop"
            :title="cItem.label"
            :header-align="'center'"
            :align="cItem.align ? cItem.align : 'center'"
            :fixed="cItem.fixed ? cItem.fixed : null"
            :cell-render="cItem.cellRender ? cItem.cellRender : null"
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <div class="footerCostCount" v-if="footerCost.label">
      <span class="label">{{ footerCost.label }}：</span>
      <span class="money">{{ footerCost.val }}</span>
    </div>
    <div class="pageWrap" v-if="pageData.page && !tableData.config.pageMin">
      <vxe-pager
        background
        :current-page="pageData.pageNum"
        :page-size="pageData.pageSize"
        :page-sizes="pageSizes"
        :total="parseInt(pageData.total)"
        :layouts="[
          'Total',
          'PrevPage',
          'JumpNumber',
          'NextPage',
          'FullJump',
          'Sizes'
        ]"
        @page-change="handlePageChange"
      />
    </div>
    <div
      class="pageMin pageWrap"
      v-if="pageData.page && tableData.config.pageMin"
    >
      <div class="buttons">
        <slot name="buttons" />
      </div>
      <vxe-pager
        v-if="tableData.config.pageMin"
        :current-page.sync="pageData.pageNum"
        :page-size.sync="pageData.limitNum"
        :total="parseInt(pageData.total)"
        align="center"
        :layouts="['PrevPage', 'JumpNumber', 'NextPage']"
        @page-change="handlePageChange"
      />
    </div>
  </div>
</template>
<script>
// 文档地址: https://xuliangzhan_admin.gitee.io/vxe-table/#/table/start/install
// github地址: https://github.com/xuliangzhan/vxe-table
import API from '@/API/request';

export default {
  name: 'CommonTable',
  props: {
    editMode: {
      // 编辑模式  默认为行编辑  row || cell
      type: String,
      default: 'row'
    },
    editTriggerMode: {
      // 编辑触发方式 默认点击触发编辑模式  manual(手动触发,只能用于editMode=row)||click||dblclick
      type: String,
      default: 'click'
    },
    editAutoClear: {
      // 如果设置为手动模式(false)则不会自动关闭激活状态，需要手动调用 clearActived 关闭编辑状态
      type: Boolean,
      default: true
    },
    isEditTable: {
      // 是否允许表格编辑的flag  配合whetherEditMethod方法使用
      type: Boolean,
      default: false
    },
    isChoiceFlag: {
      // 是否允许选择框进行勾选的flag  配合whetherCheckMethod方法使用
      type: Boolean,
      default: false
    },
    checkboxTrigger: {
      // 选择框触发方式  default || row(点击行触发) || cell(点击单元格触发)
      type: String,
      default: 'default'
    },
    handlerFooterCellClass: {
      // 给表尾附加className  Function({$rowIndex, column, columnIndex, $columnIndex})
      type: Function,
      default: () => {
        return () => {};
      }
    },
    mergeFooterData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    footerCost: {
      type: Object,
      default: () => {
        return {};
      }
    },
    pageSizes: {
      // 分页大小列表
      type: Array,
      default: () => {
        return [10, 15, 20, 25];
      }
    },
    dataFilterMethod: [Function],
    footerMethodHandler: [Function], // 设置表尾数据方法(做合计等业务使用)  返回一个二维数组 Function({columns, data})
    whetherEditMethod: [Function], // 是否允许编辑  该方法的返回值用来决定该单元格是否允许编辑  Function({ row, rowIndex, column, columnIndex })
    tableRowClassName: [Function], // 给行附加className  Function({row, rowIndex, $rowIndex})
    cellClassName: [Function], // 给单元格附加className  Function({row, rowIndex, $rowIndex, column, columnIndex, $columnIndex})
    whetherCheckMethod: [Function] // 是否允许选择框勾选  该方法的返回值用来决定这一行的 Radio || checkbox 是否可以选中  Function({ row })
  },
  data () {
    return {
      tableData: {
        columns: [],
        dataList: [],
        config: {
          height: 'auto',
          maxHeight: 'none',
          border: 'default',
          highlightHoverRow: true
        }
      },
      pageData: {
        page: true,
        pageNum: 1,
        pageSize: 10,
        total: 1,
        disabled: false
      },
      staticTableList: [],
      tableParams: {},
      listKey: '',
      requestUrl: '',
      loading: false,
      APIMethod: '',
      staticTableFlage: false
    };
  },
  computed: {
    mergeFooterItems () {
      return JSON.parse(JSON.stringify(this.mergeFooterData));
    }
  },
  methods: {
    /**
     * @method loadTable: 表格初始化
     * @param  obj {Object}: {
     *   url: 请求路径,
     *   listKey: 返回数据list的key,
     *   params: 请求参数,
     *   method: 请求方式
     * }
     */
    loadTable ({ url, listKey = null, params = {}, method = 'post' }) {
      this.requestUrl = url;
      this.tableParams = params;
      this.listKey = listKey;
      this.APIMethod = method;
      return this.getTableData({ url: this.requestUrl, params: this.tableParams });
    },
    /**
     * @method getTableData: 表格数据请求
     * @param  obj {Object}: {
     *   url: 请求路径,
     *   params: 请求参数,
     *   first: 是否是第一次请求
     * }
     */
    getTableData ({ url, params = {}, first = false }) {
      if (!params) {
        this.tableParams = {};
      } else {
        this.tableParams = params;
      }
      // 新增如果是first搜索按钮点击重置页码到1
      if(first){
        this.$set(this.pageData, 'pageNum', 1)
      }
      let paramsObj = {};
      if (this.pageData.page === false) {
        paramsObj = {
          ...this.tableParams
        };
      } else {
        paramsObj = {
          pageNum: this.pageData.pageNum,
          pageSize: this.pageData.pageSize,
          ...this.tableParams
        };
      }
      let paramsHandler = '';
      if (Object.keys(paramsObj).length > 0 && this.APIMethod === 'get') {
        paramsHandler = '/' + Object.values(paramsObj).join('/');
      }
      this.loading = true;
      return new Promise((resolve, reject) => {
        API({
          method: this.APIMethod,
          url: `${url}${paramsHandler}`,
          data: this.APIMethod === 'post' ? paramsObj : null
        }).then(res => {
          if (res.status === '200') {
            const responseData = res.data || {};
            const pageInfo = responseData.pageInfo;
            const hasPageInfo = pageInfo && typeof pageInfo === 'object' && !Array.isArray(pageInfo) && (
              Object.prototype.hasOwnProperty.call(pageInfo, 'total') ||
              (this.listKey && Object.prototype.hasOwnProperty.call(pageInfo, this.listKey))
            );
            const tableResponseData = hasPageInfo ? pageInfo : responseData;
            let list = [];
            if (this.listKey) {
              list = tableResponseData[this.listKey] || [];
              this.pageData.total = tableResponseData.total;
            } else {
              list = tableResponseData;
            }
            // 如果提供有过滤方法，则走一遍过滤方法
            this.tableData.dataList = this.dataFilterMethod
              ? this.dataFilterMethod(list)
              : list;
            this.$emit('handleTableList', this.tableData.dataList);
            resolve(this.tableData.dataList);
          } else {
            // this.$message.error(res.err);
            reject(res.err);
          }
          this.loading = false;
        });
      });
    },
    /**
     * @method setColumn: 静态表格初始化
     * @param  column { object }: 设置列属性
     * @param  tableConfig { object }: 设置表格基本属性
     * tableConfig.rowId: 自定义行数据唯一主键的字段名（行数据必须要有唯一主键，默认自动生成）
     * tableConfig.headerShow: 是否显示表头 - 默认true
     * tableConfig.border: 是否显示表格边框 - 默认true - outer(外边框) | inner(内边框) | none(无边框)
     * tableConfig.highlightHoverRow: 鼠标移入是否高亮该行 - 默认true
     * tableConfig.page: 是否显示分页 - 默认true
     * tableConfig.resizable: 是否可以拖动调整列宽 - 默认不可调整列宽
     * tableConfig.showFooter: 是否显示表尾 - 默认不显示
     * tableConfig.showIndex: 是否显示序号 - 默认不显示
     * tableConfig.customEmpty: 表格为空时，自定义元素 - 默认暂无数据
     * tableConfig.pageMin: 是否显示缩略版分页 - 默认正常分页
     * tableConfig.checkboxReserve: 是否保留勾选状态，例如：数据被刷新或者分页之后还保留之前选中的状态，启用 reserve 功能需要设置row-id(绑定数据中的一个唯一主键)，可以通过调用 getCheckboxReserveRecords 方法获取获取已保留选中的行数据
     */
    setColumn (column, tableConfig = {}) {
      this.tableData.columns = column;
      this.tableData.config = tableConfig;
      this.tableData.config.rowId = this.tableData.config.rowId
        ? this.tableData.config.rowId
        : '_XID';
      if (tableConfig.headerShow === undefined) {
        this.pageData.headerShow = true;
      }
      if (tableConfig.border) {
        this.tableData.config.border = tableConfig.border;
      } else {
        this.tableData.config.border = 'default';
      }
      if (tableConfig.highlightHoverRow === undefined) {
        this.tableData.config.highlightHoverRow = true;
      }
      if (tableConfig.page === false) {
        this.pageData.page = tableConfig.page;
      } else {
        this.pageData.pageNum = tableConfig.pageNum
          ? tableConfig.pageNum
          : this.pageData.pageNum;
        this.pageData.pageSize = tableConfig.pageSize
          ? tableConfig.pageSize
          : this.pageData.pageSize;
      }
    },
    /**
     * @method loadStaticTable: 静态表格初始化
     * @param  data { Array }: 表格数据
     * @param  pageTotal { Number }: 分页总条数   默认为0
     */
    loadStaticTable (data, pageTotal) {
      this.staticTableFlage = true;
      if (this.pageData.page) {
        // 前端假分页全部数据
        this.staticTableList = data;
        this.pageData.total = pageTotal || 0;
        this.staticTableHandler();
      } else {
        this.tableData.dataList = data;
      }
    },
    staticTableHandler () {
      let start =
        this.pageData.pageNum <= 1
          ? 0
          : (this.pageData.pageNum - 1) * this.pageData.pageSize;
      let end =
        start <= 1 ? this.pageData.pageSize : start + this.pageData.pageSize;
      // 假分页显示数据
      this.tableData.dataList = this.staticTableList.slice(start, end);
    },
    handlePageChange ({ type, currentPage, pageSize, $event }) {
      this.pageData.pageNum = currentPage;
      this.pageData.pageSize = pageSize;
      if (this.staticTableFlage) {
        this.staticTableHandler();
      } else {
        this.getTableData({ url: this.requestUrl, params: this.tableParams });
      }
      this.$emit('handlePageChange', { currentPage, pageSize });
    },
    /**
     * @method editActivedEvent: 单元格被激活编辑时会触发该事件
     * @param  obj {Object}: { row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }
     */
    editActivedEvent ({
      row,
      rowIndex,
      $rowIndex,
      column,
      columnIndex,
      $columnIndex
    }) {
      this.$emit('editActivedEvent', {
        row,
        rowIndex,
        $rowIndex,
        column,
        columnIndex,
        $columnIndex
      });
    },
    /**
     * @method editClosed: 单元格编辑状态下被关闭时会触发该事件
     * @param  data {Object}: { row, rowIndex, $rowIndex, column, columnIndex, $columnIndex }
     */
    editClosed (data) {
      this.$emit('editClosed', data);
    },
    /**
     * @method clearActived: 清除单元格激活状态
     */
    clearActived () {
      this.$refs.commonTable.clearActived();
    },
    /**
     * @method refreshColumn: 刷新列  更改了列属性，需要手动刷新列
     */
    refreshColumn () {
      this.$refs.commonTable.refreshColumn();
    },
    /**
     * @method setActiveCell: 设置单元格激活状态
     * @param row {Object}: 行
     * @param property {String}: 属性
     */
    setActiveCell (row, property) {
      this.$refs.commonTable.setActiveCell(row, property);
    },
    /**
     * @method setActiveCell: 设置整行的激活状态  编辑模式得是row
     * @param row {Object}: 行
     */
    setActiveRow (row) {
      this.$nextTick(() => {
        this.$refs.commonTable.setActiveRow(row);
      });
    },
    /**
     * @method activeEditMethod: 是否允许编辑单元格, prop传入whetherEditMethod方法(该方法返回值决定是否可编辑),配合isEditTable使用
     *
     */
    activeEditMethod ({ row, rowIndex, column, columnIndex }) {
      if (this.isEditTable) {
        return this.whetherEditMethod({ row, rowIndex, column, columnIndex });
      } else {
        return true;
      }
    },
    /**
     * @method insertRow: 插入一行
     * @param record {Object}: 插入行数据
     * @param row {null | Number}: 指定插入位置（不支持树表格），null从第一行插入、-1 从最后插入，默认 -1
     */
    insertRow (record = {}, row = null) {
      if (row && typeof row === 'number') {
        this.tableData.dataList.splice(row, 0, record);
        return;
      }
      this.tableData.dataList.push(record);
    },
    /**
     * @method staticRemoveRow: 删除一行 - 前端假分页使用这个删除方法
     * @param row {Object}: 删除指定某行数据
     */
    staticRemoveRow (row) {
      this.removeRow(row);
      let { rowId } = this.tableData.config;
      let rowIndex = this.staticTableList.findIndex(item => {
        return item[rowId] === row[rowId];
      });
      this.staticTableList.splice(rowIndex, 1);
      this.pageData.total = this.pageData.total - 1;
      if (this.tableData.dataList.length === 0) {
        this.pageData.pageNum = this.pageData.pageNum - 1;
        if(this.pageData.pageNum===0){
          this.pageData.pageNum=1
        }
        this.staticTableHandler();
      }
    },
    /**
     * @method removeRow: 删除一行
     * @param row {Object}: 删除指定某行数据
     */
    removeRow (row) {
      let rowIndex = this.getRowIndex(row);
      this.tableData.dataList.splice(rowIndex, 1);
    },
    /**
     * @method removeRow: 删除选中的数据
     */
    removeCheckboxRow () {
      this.$refs.commonTable.removeCheckboxRow();
    },
    /**
     * @method staticReviseRow: 替换某行数据 - 前端假分页修改数据使用这个方法
     * @param row {Object}: 修改的行对象
     */
    staticReviseRow (row) {
      this.reviseRow(row);
      let { rowId } = this.tableData.config;
      let rowIndex = this.staticTableList.findIndex(item => {
        return item[rowId] === row[rowId];
      });
      this.$set(this.staticTableList, rowIndex, row);
    },
    /**
     * @method reviseRow: 修改行数据 || 替换某行数据
     * @param  row {Object}: 修改的行对象
     * @param  property {String | Object}: 行属性
     * @param  value {String}: 值
     */
    reviseRow (row, property, value) {
      let rowIndex = this.getRowIndex(row);
      if (property) {
        if (property instanceof Object) {
          for (let key in property) {
            this.tableData.dataList[rowIndex][key] = property[key];
          }
        } else {
          this.tableData.dataList[rowIndex][property] = value;
        }
      } else {
        this.$set(this.tableData.dataList, rowIndex, row);
      }
      this.refreshColumn();
    },
    handleCurrentChange () {
      // { row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, $event }
    },
    /**
     * @method checkMethod: 选择框是否可选,prop传入whetherCheckMethod方法(该方法的返回值用来决定这一行的 Radio || checkbox 是否可以选中),配合isChoiceFlag使用
     * @param  obj {Object}: { row }
     */
    checkMethod ({ row }) {
      if (this.isChoiceFlag) {
        return this.whetherCheckMethod({ row });
      } else {
        return true;
      }
    },
    /**
     * @method getCheckboxReserveRecords: 用于 checkbox-config.reserve，获取已保留选中的行数据（不包含当前列表, 获取当前列表数据使用getCheckboxRecords）
     */
    getCheckboxReserveRecords () {
      return this.$refs.commonTable.getCheckboxReserveRecords();
    },
    /**
     * @method clearCheckboxReserve: 用于 checkbox-config.reserve，手动清空用户保留选中的行数据
     */
    clearCheckboxReserve () {
      this.$refs.commonTable.clearCheckboxReserve();
    },
    /**
     * @method handleRadioChange: 单选框改变时触发
     * @param  item {Object}: { row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, $event }
     */
    handleRadioChange (item) {
      this.$emit('radioChange', item);
    },
    /**
     * @method getCheckboxRecords: 获取多选框选中项
     */
    getCheckboxRecords () {
      return this.$refs.commonTable.getCheckboxRecords();
    },
    /**
     * @method setCheckboxRow: 设置多选框选中项
     * @param  rows {Array}: 选中行  [{row1}, {row2}]
     */
    setCheckboxRow (rows) {
      this.$refs.commonTable.setCheckboxRow(rows, true);
    },
    /**
     * @method handleSelectChange: 多选框改变时触发
     * @param  item {Object}: { records, reserves, indeterminates, checked, row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, $event }
     */
    handleSelectChange (item) {
      this.$emit('handleSelectChange', item);
    },
    /**
     * @method handleCheckBoxAll: 全选改变时触发
     * @param  val {Object}: { records, reserves, indeterminates, checked, $event }
     */
    handleCheckBoxAll (val) {
      this.$emit('handleCheckBoxAll', val);
    },
    /**
     * @method handleCellClick: 单元格点击时触发val
     * @param  val {Object}: { row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, triggerRadio, triggerCheckbox, triggerTreeNode, triggerExpandNode, $event }
     */
    handleCellClick (val) {
      this.$emit('handleCellClick', val);
    },
    /**
     * @method handleCellDblclick: 单元格双击时触发
     * @param  val {Object}: { row, rowIndex, $rowIndex, column, columnIndex, $columnIndex, $event }
     */
    handleCellDblclick (val) {
      this.$emit('handleCellDblclick', val);
    },
    /**
     * @method footerMethod: 设置表尾方法, 使用时初始化表格时配置 tableData.config.showFooter = true
     * @param object {Object}: { columns, data }
     */
    footerMethod ({ columns, data }) {
      return this.footerMethodHandler({ columns, data });
    },
    /**
     * @method updateFooter: 更新表尾，表尾合计更新时，需手动调用该方法更新
     */
    updateFooter () {
      this.$refs.commonTable.updateFooter();
    },
    /**
     * @method footerMethod: 表尾附加className方法
     * @param object {Object}: { $rowIndex, column, columnIndex, $columnIndex }
     */
    footerCellClassName ({ $rowIndex, column, columnIndex, $columnIndex }) {
      return this.handlerFooterCellClass({ $rowIndex, column, columnIndex });
    },
    /**
     * @method getRowIndex: 获取某行的下标
     * @param  row {Object}: 行数据
     */
    getRowIndex (row) {
      if (row) {
        let { rowId } = this.tableData.config;
        let index = this.tableData.dataList.findIndex(item => {
          return item[rowId] === row[rowId];
        });
        return index;
      }
    }
  },
  mounted () {}
};
</script>

<style lang="scss">
@import "@/style/common";
.common_table {
  overflow: hidden;
  > .vxe-table {
    min-height: 100px;
    > .vxe-loading {
      .vxe-loading--spinner:after,
      .vxe-loading--spinner:before {
        background-color: #14937b;
      }
    }
    // 外层边框 - table整个方块的外部边框
    > .vxe-table--border-line {
      border: 1px solid #dee1e7;
    }
    > .vxe-table--fixed-left-wrapper.scrolling--middle {
      box-shadow: 4px 0 7px 0 rgb(0 0 0 / 12%);
      border-right: 1px solid #dee1e7;
    }
    > .vxe-table--fixed-right-wrapper.scrolling--middle {
      box-shadow: -4px 0 7px 0px rgb(0 0 0 / 12%);
      border-left: 1px solid #dee1e7;
    }

    &.border--full .vxe-table--fixed-left-wrapper {
      border-right: none;
    }

    .fixed--hidden {
      visibility: visible;
    }

    .vxe-table--header-wrapper {
      background: #f6f7f9;
      &::before {
        content: "";
        display: block;
        height: 1px;
        background: #ffffff;
        position: relative;
        top: 1px;
      }
      .vxe-table--header-border-line {
        border: none;
      }

      > table {
        width: 100% !important;

        .vxe-header--row {
          > .vxe-header--column {
            padding: 18px 0;
            background-image: linear-gradient(#e2e4e9, #e2e4e9);
            // background: none;
            // border-bottom: 1px solid #E2E4E9;
            &:first-child > .vxe-cell {
              padding-left: 20px;
            }
            &:last-child > .vxe-cell {
              padding-right: 20px;
            }
          }
        }
        .vxe-cell {
          line-height: 1;
          color: #5b646e;
          padding: 0 10px;
          font-weight: 400;
          > .vxe-cell--title {
            line-height: 1.2;
          }
          .vxe-cell--checkbox {
            &:hover > .vxe-checkbox--icon:before {
              border-color: #17a58a;
            }
            // 普通状态
            > .vxe-checkbox--icon {
              font-size: 16px;
              &:before {
                border: 1px solid #c4c8cf;
                border-radius: 2px;
              }
            }
            // 半选状态
            > .vxe-checkbox--indeterminate-icon {
              &:before {
                border: 1px solid #c4c8cf;
                background: #ffffff;
              }
              &:after {
                border: none;
                background: #14937b;
                transform: translate(-50%, -50%) rotate(0);
                width: 0.46em;
                height: 0.46em;
              }
            }
            // 选中状态
            > .vxe-checkbox--checked-icon {
              &:before {
                background: #17a58a;
                border-color: #17a58a;
              }
            }
          }
        }
      }
    }

    .vxe-table--body-wrapper {
      background: #fcfdfe;
      > .vxe-table--empty-block {
        min-height: 48px;
      }
      > table {
        width: 100% !important;

        .row--stripe {
          background: #f3f5f8;
        }

        .vxe-body--row.row--hover {
          background: #eaf5f4;
        }

        .el-input-number--medium {
          width: auto;
        }

        .el-date-editor.el-input {
          width: auto;
        }

        .el-button {
          white-space: normal;
          &.single {
            width: 100%;
          }
        }
        .el-dropdown {
          margin: 0 8px;
          > .el-dropdown-link {
            color: #508db4;
            cursor: pointer;
            &:hover {
              color: #3397d4;
            }
            > i {
              margin-left: 4px;
            }
          }
        }

        .el-button--text.is-disabled {
          color: #b8b8b8;
        }

        .vxe_editDialog {
          color: #3384fe;

          &:hover {
            cursor: pointer;
          }
        }

        .vxe-body--column {
          padding: 5px 0;
          line-height: 18px;
          height: 48px;
          // background-image: linear-gradient(#E2E4E9,#E2E4E9);
          background: none;
          border-bottom: 1px solid #e2e4e9;
          &.col--dirty:before {
            display: none;
          }
          &:first-child > .vxe-cell {
            padding-left: 20px;
          }
          &:last-child > .vxe-cell {
            padding-right: 20px;
          }
        }

        .vxe-cell {
          width: auto !important;
          max-height: none;
          color: #424c57;
          padding: 0 10px;
          .el-button--text {
            min-width: auto;
            padding: 0 !important;
            border: none;
            & + .el-button--text {
              position: relative;
              margin-left: 16px;
              &:before {
                content: "";
                display: block;
                width: 1px;
                height: 12px;
                background: #cad0d6;
                position: absolute;
                top: 50%;
                margin-top: -6px;
                left: -8px;
              }
            }
          }
          .el-button--text + .el-dropdown {
            position: relative;
            margin-left: 16px;
            &:before {
              content: "";
              display: block;
              width: 1px;
              height: 12px;
              background: #cad0d6;
              position: absolute;
              top: 50%;
              margin-top: -6px;
              left: -8px;
            }
          }
          .el-input-number {
            width: 100%;
            line-height: 34px;
            > span {
              width: 32px;
              height: 32px;
              top: 2px;
            }

            > .el-input > input {
              padding-left: 36px;
              padding-right: 36px;
            }
            &.is-without-controls {
              input {
                padding: 0 12px;
                text-align: right;
              }
            }
          }
          .btnText {
            color: #508db4;
            cursor: pointer;
            &:hover {
              color: #3397d4;
            }
          }
          .vxe-cell--checkbox {
            &:hover > .vxe-checkbox--icon:before {
              border-color: #17a58a;
            }
            > .vxe-checkbox--icon {
              font-size: 16px;
              &:before {
                border: 1px solid #c4c8cf;
                border-radius: 2px;
              }
            }
            > .vxe-checkbox--checked-icon {
              &:before {
                border-color: #17a58a;
                background: #17a58a;
              }
              &:after {
                border: 1.8px solid #fff;
                border-left: none;
                border-top: none;
              }
            }
          }
        }
      }

      /*滚动条整体样式*/
      &::-webkit-scrollbar {
        width: 8px;
        height: 8px;
      }

      /*滚动条滑块*/
      &::-webkit-scrollbar-thumb {
        //border-radius: 5px;
        //-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
        //background: rgba(83, 83, 83, 0.72);

        //border-radius   : 10px;
        //background-color: skyblue;
        //background-image: -webkit-linear-gradient(
        //  45deg,
        //  rgba(255, 255, 255, 0.2) 25%,
        //  transparent 25%,
        //  transparent 50%,
        //  rgba(255, 255, 255, 0.2) 50%,
        //  rgba(255, 255, 255, 0.2) 75%,
        //  transparent 75%,
        //  transparent
        //);
        border-radius: 5px;
        cursor: pointer;
        background: rgba(144, 147, 153, 0.3);

        &:hover {
          background: rgba(144, 147, 153, 0.5);
        }
      }

      /*滚动条轨道*/
      &::-webkit-scrollbar-track {
        //-webkit-box-shadow: inset 0 0 1px rgba(0,0,0,0);
        //border-radius: 10px;
        //background: #ccc;
        //box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.2);
        //background   : #ededed;
        //border-radius: 10px;
        border-radius: 10px;
        background: #ffffff;
      }
    }
  }

  > .footerCostCount {
    height: 48px;
    line-height: 48px;
    color: #424c57;
    font-size: 16px;
    padding: 0 20px;
    background: #fcfdfe;
    border: 1px solid #e2e4e9;
    border-top: none;
    > .money {
      color: #14937b;
    }
  }

  .pageWrap {
    margin-top: 10px;
    .vxe-pager {
      background-color: transparent;
      color: #424c58;
      .vxe-pager--prev-btn > i:after {
        transform: rotate(180deg);
      }
      .vxe-pager--prev-btn,
      .vxe-pager--next-btn {
        background-color: #f6f7f9;
        border: 1px solid #d7d8da;
        color: #6b7279;
        > i {
          font-style: normal;
          font-size: 12px;
          &:before {
            border: none;
          }
          &:after {
            content: "\e62a";
            display: block;
            font-family: "iconfont" !important;
          }
        }
        &:not(.is--disabled):hover {
          border: 1px solid #17a58a;
        }
        &.is--disabled {
          color: #c6c6c6;
          border: 1px solid #d9d9d9;
        }
      }
      .vxe-pager--btn-wrapper {
        > .vxe-pager--num-btn {
          padding: 0 4px;
          background-color: #f6f7f9;
          border: 1px solid #d7d8da;
        }
        > .vxe-pager--num-btn:not(.is--disabled):hover {
          border: 1px solid #17a58a;
          color: #424c58;
        }
        > .is--active {
          background-color: #14937b;
          color: #ffffff !important;
          border: 1px solid #14937b;
        }
        & > .vxe-pager--jump-prev,
        & > .vxe-pager--jump-next {
          color: #c0c0c0;
          background: transparent;
          line-height: 1.8em;
          &:not(.is--disabled):hover {
            color: #17a58a;
          }
        }
      }
      .vxe-pager--jump {
        > input:focus {
          border: 1px solid #14937b;
        }
      }
      .vxe-select {
        > .is--active > input {
          border: 1px solid #14937b;
        }
        > .vxe-select--panel > .vxe-select-option--wrapper {
          color: #424c57;
          > .is--selected {
            color: #14937b;
          }
          > .vxe-select-option:not(.is--disabled).is--hover {
            //background: rgba(18,146,122,.8);
            background: #ecf6f5;
            //opacity: .8;
          }
        }
      }
    }
  }

  .pageMin {
    @extend .clear;
    > .buttons {
      float: left;
    }
    > .vxe-pager {
      float: right;
    }
  }

  @media screen and (max-width: 1460px) {
    .vxe-table .vxe-cell {
      font-size: 12px;

      span {
        font-size: 12px;
      }

      .el-input {
        height: 32px;
      }

      .el-select {
        height: 32px;

        input {
          height: 32px;
          line-height: 32px;
          font-size: 12px;
        }

        .el-input--medium .el-input__icon {
          line-height: 32px;
        }
      }
    }
  }

  // 表尾内容居中样式
  .footer-cell-center {
      >.vxe-cell {
          display: flex;
          align-items: center;
          justify-content: center;
      }
  }
}
</style>
